import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTableFilterBoolean, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterSelect, LazyTableFilterString, LazyTableToolGeneralExport, LazyTableToolLoginProvidersCreate, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyStrapiComponent, LazyStrapiBaseBild, LazyStrapiBaseBreadcrumbs, LazyStrapiBaseBundeslaenderUebersicht, LazyStrapiBaseBundeslaenderUebersichtBundesland, LazyStrapiBaseBundeslandKopfzeile, LazyStrapiBaseBundeslandSeitenTitel, LazyStrapiBaseBundeslandSeitenWechsel, LazyStrapiBaseBundeslandSeitenWechselBundeslandFlagge, LazyStrapiBaseDownloads, LazyStrapiBaseFaq, LazyStrapiBaseSeitenTitel, LazyStrapiBaseTextBlockJson, LazyStrapiLandingPageBundeslaender, LazyStrapiLandingPageBundeslaenderBundesland, LazyStrapiLandingPageInfoBlock, LazyStrapiLandingPageKacheln, LazyStrapiLandingPageKachelnWrapper, LazyStrapiLandingPageMeldungen, LazyStrapiMenuFusszeileLink, LazyStrapiMenuFusszeileSeite, LazyStrapiMenuKopfzeileBundeslaender, LazyStrapiMenuKopfzeileBundeslaenderKopfzeileBundesland, LazyStrapiMenuKopfzeileSeite, LazyStrapiSpecialJuleicaNummerCheck, LazyStrapiSpecialKontakt, LazyStrapiSpecialStatistik, LazyBlockRendererHeading1Node, LazyBlockRendererHeading2Node, LazyBlockRendererHeading3Node, LazyBlockRendererHeading4Node, LazyBlockRendererHeading5Node, LazyBlockRendererHeading6Node, LazyBlockRendererImageNode, LazyBlockRendererLinkInlineNode, LazyBlockRendererOrderedListNode, LazyBlockRendererParagraphNode, LazyBlockRendererUnorderedListNode, LazyActivityLog, LazyBaseAlert, LazyBaseBadge, LazyBaseBoolean, LazyBaseButton, LazyBaseCard, LazyBaseDate, LazyBaseDropdown, LazyBaseMenuItem, LazyBaseListing, LazyBaseListingHeader, LazyBaseListingValue, LazyBaseLoadingRows, LazyBaseModal, LazyBasePage, LazyBasePageActionMenu, LazyBasePageButton, LazyBasePageHeader, LazyBasePageHeading, LazyBasePageLink, LazyBasePageTabs, LazyBaseStrapi404Page, LazyBaseStrapiPage, LazyBaseStrapiPageMenu, LazyBasePopover, LazyBaseSlideOver, LazyBaseSubmitButtons, LazyBaseSwitch, LazyActionButton, LazyCreateAction, LazyFilterAction, LazyToolAction, LazyActionWindow, LazyTableActions, LazyBaseTable, LazyFilterBadge, LazyTableFilter, LazyTableFilters, LazyBaseCounter, LazyBasePagination, LazyBasePerPageSetting, LazyTableSelection, LazyTableTool, LazyDeleteModal, LazyEnvBanner, LazyAutocompleteCity, LazyBaseCheckbox, LazyBaseCombobox, LazyBaseDropzone, LazyBaseInput, LazyBaseRadio, LazyBaseSearchSelect, LazyBaseSelect, LazyBaseTextArea, LazyQuickValidator, LazyJuleicaBaseCard, LazyJuleicaTable, LazyJuleicaTableBody, LazyJuleicaTableBodyRow, LazyJuleicaTableColumn, LazyJuleicaTableHead, LazyLoadingSpinner, LazyLogoImage, LazyNotificationArea, LazyNotificationBanner, LazyNotificationFeed, LazyNotificationInbox, LazyPageElementWrapper, LazyPasswordStrengthMeter, LazyLogType, LazyRequestLog, LazyProfilePicture, LazyUserTable, LazyCircles, LazyFooter, LazyFooterCircles, LazyGlobalSearch, LazySearchPopover, LazySearchable, LazyHeader, LazyImpersonateBanner, LazyMainMenu, LazySidebar, LazyReleaseNotes, LazyUserInfoModal, LazyUserMenu, LazyWikiNavItem, LazyWikiSidebar, LazyJuleicaOrganisationsMap, LazyApplicationSteps, LazyFsExtension, LazyFsExtensionBayernVolunteerCards, LazyFsExtensionSachsenVolunteerCards, LazyStatistic, LazyStatisticBoolean, LazyStatisticCheck, LazyStatisticGrades, LazyStatisticSelect, LazyStatisticText, LazyStepApplicationSubmitError, LazyStepApplicationSubmitLoading, LazyStepApplicationSubmitSuccess, LazyStepCheck, LazyStepEducation, LazyStepEmail, LazyStepPersonalDetails, LazyAuthForgotPassword, LazyAuthLogin, LazyAuthRegister, LazyAuthResetPassword, LazySocialiteOptions, LazyOpenAiDemo, LazyJuleica, LazyStatisticBetweenDate, LazyStatisticLastMonth, LazyStatisticLastYear, LazyStatisticThisMonth, LazyStatisticThisYear, LazyTableFilterQuick, LazyTableFilterQuickWrapper, LazyStatisticCard, LazyStatisticCardTable, LazyStatisticCountDevelopment, LazyStatisticTable, LazyBlockRendererCodeNode, LazyBlockRendererQuoteNode, LazyBlockRendererBoldInlineNode, LazyBlockRendererCodeInlineNode, LazyBlockRendererItalicInlineNode, LazyBlockRendererListItemInlineNode, LazyBlockRendererStrikethroughInlineNode, LazyBlockRendererUnderlineInlineNode, LazyStrapiBlocksText, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterString", LazyTableFilterString],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolLoginProvidersCreate", LazyTableToolLoginProvidersCreate],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["StrapiComponent", LazyStrapiComponent],
["StrapiBaseBild", LazyStrapiBaseBild],
["StrapiBaseBreadcrumbs", LazyStrapiBaseBreadcrumbs],
["StrapiBaseBundeslaenderUebersicht", LazyStrapiBaseBundeslaenderUebersicht],
["StrapiBaseBundeslaenderUebersichtBundesland", LazyStrapiBaseBundeslaenderUebersichtBundesland],
["StrapiBaseBundeslandKopfzeile", LazyStrapiBaseBundeslandKopfzeile],
["StrapiBaseBundeslandSeitenTitel", LazyStrapiBaseBundeslandSeitenTitel],
["StrapiBaseBundeslandSeitenWechsel", LazyStrapiBaseBundeslandSeitenWechsel],
["StrapiBaseBundeslandSeitenWechselBundeslandFlagge", LazyStrapiBaseBundeslandSeitenWechselBundeslandFlagge],
["StrapiBaseDownloads", LazyStrapiBaseDownloads],
["StrapiBaseFaq", LazyStrapiBaseFaq],
["StrapiBaseSeitenTitel", LazyStrapiBaseSeitenTitel],
["StrapiBaseTextBlockJson", LazyStrapiBaseTextBlockJson],
["StrapiLandingPageBundeslaender", LazyStrapiLandingPageBundeslaender],
["StrapiLandingPageBundeslaenderBundesland", LazyStrapiLandingPageBundeslaenderBundesland],
["StrapiLandingPageInfoBlock", LazyStrapiLandingPageInfoBlock],
["StrapiLandingPageKacheln", LazyStrapiLandingPageKacheln],
["StrapiLandingPageKachelnWrapper", LazyStrapiLandingPageKachelnWrapper],
["StrapiLandingPageMeldungen", LazyStrapiLandingPageMeldungen],
["StrapiMenuFusszeileLink", LazyStrapiMenuFusszeileLink],
["StrapiMenuFusszeileSeite", LazyStrapiMenuFusszeileSeite],
["StrapiMenuKopfzeileBundeslaender", LazyStrapiMenuKopfzeileBundeslaender],
["StrapiMenuKopfzeileBundeslaenderKopfzeileBundesland", LazyStrapiMenuKopfzeileBundeslaenderKopfzeileBundesland],
["StrapiMenuKopfzeileSeite", LazyStrapiMenuKopfzeileSeite],
["StrapiSpecialJuleicaNummerCheck", LazyStrapiSpecialJuleicaNummerCheck],
["StrapiSpecialKontakt", LazyStrapiSpecialKontakt],
["StrapiSpecialStatistik", LazyStrapiSpecialStatistik],
["BlockRendererHeading1Node", LazyBlockRendererHeading1Node],
["BlockRendererHeading2Node", LazyBlockRendererHeading2Node],
["BlockRendererHeading3Node", LazyBlockRendererHeading3Node],
["BlockRendererHeading4Node", LazyBlockRendererHeading4Node],
["BlockRendererHeading5Node", LazyBlockRendererHeading5Node],
["BlockRendererHeading6Node", LazyBlockRendererHeading6Node],
["BlockRendererImageNode", LazyBlockRendererImageNode],
["BlockRendererLinkInlineNode", LazyBlockRendererLinkInlineNode],
["BlockRendererOrderedListNode", LazyBlockRendererOrderedListNode],
["BlockRendererParagraphNode", LazyBlockRendererParagraphNode],
["BlockRendererUnorderedListNode", LazyBlockRendererUnorderedListNode],
["ActivityLog", LazyActivityLog],
["BaseAlert", LazyBaseAlert],
["BaseBadge", LazyBaseBadge],
["BaseBoolean", LazyBaseBoolean],
["BaseButton", LazyBaseButton],
["BaseCard", LazyBaseCard],
["BaseDate", LazyBaseDate],
["BaseDropdown", LazyBaseDropdown],
["BaseMenuItem", LazyBaseMenuItem],
["BaseListing", LazyBaseListing],
["BaseListingHeader", LazyBaseListingHeader],
["BaseListingValue", LazyBaseListingValue],
["BaseLoadingRows", LazyBaseLoadingRows],
["BaseModal", LazyBaseModal],
["BasePage", LazyBasePage],
["BasePageActionMenu", LazyBasePageActionMenu],
["BasePageButton", LazyBasePageButton],
["BasePageHeader", LazyBasePageHeader],
["BasePageHeading", LazyBasePageHeading],
["BasePageLink", LazyBasePageLink],
["BasePageTabs", LazyBasePageTabs],
["BaseStrapi404Page", LazyBaseStrapi404Page],
["BaseStrapiPage", LazyBaseStrapiPage],
["BaseStrapiPageMenu", LazyBaseStrapiPageMenu],
["BasePopover", LazyBasePopover],
["BaseSlideOver", LazyBaseSlideOver],
["BaseSubmitButtons", LazyBaseSubmitButtons],
["BaseSwitch", LazyBaseSwitch],
["ActionButton", LazyActionButton],
["CreateAction", LazyCreateAction],
["FilterAction", LazyFilterAction],
["ToolAction", LazyToolAction],
["ActionWindow", LazyActionWindow],
["TableActions", LazyTableActions],
["BaseTable", LazyBaseTable],
["FilterBadge", LazyFilterBadge],
["TableFilter", LazyTableFilter],
["TableFilters", LazyTableFilters],
["BaseCounter", LazyBaseCounter],
["BasePagination", LazyBasePagination],
["BasePerPageSetting", LazyBasePerPageSetting],
["TableSelection", LazyTableSelection],
["TableTool", LazyTableTool],
["DeleteModal", LazyDeleteModal],
["EnvBanner", LazyEnvBanner],
["AutocompleteCity", LazyAutocompleteCity],
["BaseCheckbox", LazyBaseCheckbox],
["BaseCombobox", LazyBaseCombobox],
["BaseDropzone", LazyBaseDropzone],
["BaseInput", LazyBaseInput],
["BaseRadio", LazyBaseRadio],
["BaseSearchSelect", LazyBaseSearchSelect],
["BaseSelect", LazyBaseSelect],
["BaseTextArea", LazyBaseTextArea],
["QuickValidator", LazyQuickValidator],
["JuleicaBaseCard", LazyJuleicaBaseCard],
["JuleicaTable", LazyJuleicaTable],
["JuleicaTableBody", LazyJuleicaTableBody],
["JuleicaTableBodyRow", LazyJuleicaTableBodyRow],
["JuleicaTableColumn", LazyJuleicaTableColumn],
["JuleicaTableHead", LazyJuleicaTableHead],
["LoadingSpinner", LazyLoadingSpinner],
["LogoImage", LazyLogoImage],
["NotificationArea", LazyNotificationArea],
["NotificationBanner", LazyNotificationBanner],
["NotificationFeed", LazyNotificationFeed],
["NotificationInbox", LazyNotificationInbox],
["PageElementWrapper", LazyPageElementWrapper],
["PasswordStrengthMeter", LazyPasswordStrengthMeter],
["LogType", LazyLogType],
["RequestLog", LazyRequestLog],
["ProfilePicture", LazyProfilePicture],
["UserTable", LazyUserTable],
["Circles", LazyCircles],
["Footer", LazyFooter],
["FooterCircles", LazyFooterCircles],
["GlobalSearch", LazyGlobalSearch],
["SearchPopover", LazySearchPopover],
["Searchable", LazySearchable],
["Header", LazyHeader],
["ImpersonateBanner", LazyImpersonateBanner],
["MainMenu", LazyMainMenu],
["Sidebar", LazySidebar],
["ReleaseNotes", LazyReleaseNotes],
["UserInfoModal", LazyUserInfoModal],
["UserMenu", LazyUserMenu],
["WikiNavItem", LazyWikiNavItem],
["WikiSidebar", LazyWikiSidebar],
["JuleicaOrganisationsMap", LazyJuleicaOrganisationsMap],
["ApplicationSteps", LazyApplicationSteps],
["FsExtension", LazyFsExtension],
["FsExtensionBayernVolunteerCards", LazyFsExtensionBayernVolunteerCards],
["FsExtensionSachsenVolunteerCards", LazyFsExtensionSachsenVolunteerCards],
["Statistic", LazyStatistic],
["StatisticBoolean", LazyStatisticBoolean],
["StatisticCheck", LazyStatisticCheck],
["StatisticGrades", LazyStatisticGrades],
["StatisticSelect", LazyStatisticSelect],
["StatisticText", LazyStatisticText],
["StepApplicationSubmitError", LazyStepApplicationSubmitError],
["StepApplicationSubmitLoading", LazyStepApplicationSubmitLoading],
["StepApplicationSubmitSuccess", LazyStepApplicationSubmitSuccess],
["StepCheck", LazyStepCheck],
["StepEducation", LazyStepEducation],
["StepEmail", LazyStepEmail],
["StepPersonalDetails", LazyStepPersonalDetails],
["AuthForgotPassword", LazyAuthForgotPassword],
["AuthLogin", LazyAuthLogin],
["AuthRegister", LazyAuthRegister],
["AuthResetPassword", LazyAuthResetPassword],
["SocialiteOptions", LazySocialiteOptions],
["OpenAiDemo", LazyOpenAiDemo],
["Juleica", LazyJuleica],
["StatisticBetweenDate", LazyStatisticBetweenDate],
["StatisticLastMonth", LazyStatisticLastMonth],
["StatisticLastYear", LazyStatisticLastYear],
["StatisticThisMonth", LazyStatisticThisMonth],
["StatisticThisYear", LazyStatisticThisYear],
["TableFilterQuick", LazyTableFilterQuick],
["TableFilterQuickWrapper", LazyTableFilterQuickWrapper],
["StatisticCard", LazyStatisticCard],
["StatisticCardTable", LazyStatisticCardTable],
["StatisticCountDevelopment", LazyStatisticCountDevelopment],
["StatisticTable", LazyStatisticTable],
["BlockRendererCodeNode", LazyBlockRendererCodeNode],
["BlockRendererQuoteNode", LazyBlockRendererQuoteNode],
["BlockRendererBoldInlineNode", LazyBlockRendererBoldInlineNode],
["BlockRendererCodeInlineNode", LazyBlockRendererCodeInlineNode],
["BlockRendererItalicInlineNode", LazyBlockRendererItalicInlineNode],
["BlockRendererListItemInlineNode", LazyBlockRendererListItemInlineNode],
["BlockRendererStrikethroughInlineNode", LazyBlockRendererStrikethroughInlineNode],
["BlockRendererUnderlineInlineNode", LazyBlockRendererUnderlineInlineNode],
["StrapiBlocksText", LazyStrapiBlocksText],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
